import React from "react";
import {
  Container,
  Paper,
  Typography,
  Box,
  Link,
  Divider
} from "@mui/material";

const WelcomePage = () => {
  return (
    <Container maxWidth="md">
      <Paper
        elevation={3}
        sx={{
          mt: 8,
          p: 6,
          borderRadius: 3,
          textAlign: "center",
        }}
      >
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Welcome to Capitaland DataForge
        </Typography>

        <Typography variant="body1" sx={{ mt: 3 }}>
          Capitaland DataForge Application is a secure enterprise platform that
          enables users to integrate and manage data from third-party services
          such as Google Drive and Autodesk Construction Cloud.
        </Typography>

        <Typography variant="body1" sx={{ mt: 2 }}>
          Authorized users can log in to access connectors, extract project
          data, and manage integrations securely.
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="subtitle1" fontWeight="medium">
            For more information, please contact:
          </Typography>

          <Link
            href="mailto:support@bimageconsulting.com"
            underline="hover"
            sx={{ display: "block", mt: 1 }}
          >
            support@bimageconsulting.com
          </Link>
        </Box>

        {/* Divider */}
        <Divider sx={{ my: 4 }} />

        {/* Footer Section Required by Google */}
        <Box>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Capitaland DataForge
          </Typography>

          <Box sx={{ mt: 1 }}>
            <Link
              href="/privacy-policy"
              underline="hover"
              sx={{ mx: 1 }}
            >
              Privacy Policy
            </Link>
            |
            <Link
              href="/terms-of-service"
              underline="hover"
              sx={{ mx: 1 }}
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default WelcomePage;
